import api from './api'

class AlarmsSerivice {
    async getAlarmChecks(siteId) {
        return (await api.get(`/sites/${siteId}/alarm_checks`)).data
    }

    async getAlarmCheck(id) {
        return (await api.get(`/alarm_checks/${id}`)).data
    }

    async createAlarmCheck(siteId, data) {
        return (await api.post(`/sites/${siteId}/alarm_checks`, data)).data
    }

    updateAlarmCheck(id, data) {
        return api.put(`/alarm_checks/${id}`, data)
    }

    deleteAlarmCheck(id) {
        return api.delete(`/alarm_checks/${id}`)
    }

    async getAlarms(siteId, showClosed, from = null, to = null) {
        return (await api.get(`/sites/${siteId}/alarms`, { params: { showClosed, from, to } })).data
    }

    async closeAlarm(id, close) {
        return api.put(`/alarms/${id}/close`, { close })
    }

    async getAlarmReceivers(siteId) {
        return (await api.get(`/sites/${siteId}/alarm_receivers`)).data
    }
}

export default new AlarmsSerivice()